import React from 'react';
import { Moon, Sun, PanelLeftClose, PanelLeft, HelpCircle, X } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import UserProfile from '../UserProfile';
import { AdUnit } from '../../ads';

interface AppHeaderProps {
  onHelpClick: () => void;
  sidebarCollapsed: boolean;
  onToggleSidebar: () => void;
  knownWinners?: string[];
}

const AppHeader: React.FC<AppHeaderProps> = ({ onHelpClick, sidebarCollapsed, onToggleSidebar, knownWinners }) => {
  const { theme, toggleTheme } = useTheme();
  const { impersonatingUid, impersonatingEmail, setImpersonatingUid } = useAuth();

  return (
    <>
      {impersonatingUid && (
        <div className="sticky top-0 z-50 w-full bg-orange-500 text-white text-center text-xs font-semibold py-1 px-4 flex items-center justify-center gap-2">
          <span className="truncate">God Mode: {impersonatingEmail ? `${impersonatingEmail} - ` : ''}{impersonatingUid}</span>
          <button onClick={() => setImpersonatingUid(null)} className="shrink-0 hover:text-orange-200">
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      )}
    <header className="sticky top-0 z-40 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-14 lg:h-24 items-center px-4 gap-4">
        {/* Sidebar toggle - desktop only */}
        <Button
          variant="ghost"
          size="icon"
          onClick={onToggleSidebar}
          className="hidden lg:flex"
        >
          {sidebarCollapsed ? <PanelLeft className="h-5 w-5" /> : <PanelLeftClose className="h-5 w-5" />}
        </Button>

        {/* Logo */}
        <div className="flex-1 lg:flex-none flex justify-center lg:justify-start">
          <img
            src={theme === 'dark' ? '/bracketsim_header_dark.png' : '/bracketsim_header.png'}
            alt="Tournament Bracket Simulator"
            className="h-10 lg:h-14 object-contain"
          />
        </div>

        {/* Desktop header leaderboard ad */}
        <div className="hidden lg:flex flex-1 justify-center">
          <AdUnit slotId="header-leaderboard" adSlot="3629697040" width={728} height={90} />
        </div>

        {/* Right side controls */}
        <div className="flex items-center gap-2 lg:gap-3">
          <Button variant="ghost" size="icon" onClick={toggleTheme}>
            {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
          </Button>
          <Button variant="ghost" size="icon" onClick={onHelpClick} title="Help">
            <HelpCircle className="h-5 w-5" />
          </Button>
          <UserProfile onHelpClick={onHelpClick} knownWinners={knownWinners} />
        </div>
      </div>
    </header>
    </>
  );
};

export default AppHeader;
